<template>
  <div>
    <el-row>
      <el-input placeholder="请输入地址" v-model="dbHost" clearable style="width: 200px"></el-input>
      <el-input placeholder="请输入用户名" v-model="dbUser" clearable style="width: 200px;margin-left: 10px"></el-input>
      <el-input placeholder="请输入密码" v-model="dbPassword" show-password
                style="width: 200px;margin-left: 10px"></el-input>
      <el-button type="primary" style="margin-left: 10px" v-if="listOperations.some(func => func.name.includes('uncertified'))"
                 @click="isIdentifyConnect('false')">建立非认证连接</el-button>
      <el-button type="danger" v-if="listOperations.some(func => func.name.includes('certified'))"
                 @click="isIdentifyConnect('true')" style="margin-left: 10px">建立认证连接</el-button>
    </el-row>
    <div style="margin-top: 10px">
      <el-row>
        <el-date-picker v-model="start" type="datetime" placeholder="开始日期" style="width: 200px;"
                        value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        <el-date-picker v-model="end" type="datetime" placeholder="结束日期" style="width: 200px;margin-left: 10px"
                        value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      </el-row>
    </div>
    <div style="margin-top: 10px">
      <el-row>
        <el-col :span="6">
          <el-table
            :data="dbInfoArr"
            :header-cell-style="{'textAlign':'center'}"
            border
            :highlight-current-row="true"
            @row-click="chooseDB"
            style="width: 100%">
            <el-table-column align="center"
                             prop="key"
                             label="数据库概要信息">
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="18">
          <div style="margin-left: 15px">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="可以直接删除的集合" name="dataDel">
                <el-button type="primary" size="small" style="float: right;margin-right: 20px;" @click="nameDel"
                           v-if="listOperations.some(func => func.name.includes('nameDel'))">开始删除数据</el-button>
                <el-table
                  :data="dataDelData"
                  :header-cell-style="{'textAlign':'center'}"
                  style="width: 100%"
                  @selection-change="handleSelectionChange" >
                  <el-table-column align="center"
                                   type="selection"
                                   width="55">
                  </el-table-column>
                  <el-table-column align="center"
                                   prop="collectionName"
                                   label="集合名称">
                  </el-table-column>
                  <el-table-column align="center"
                                   prop="count"
                                   label="记录数">
                  </el-table-column>
                  <el-table-column align="center"
                                   prop="size"
                                   label="容量大小">
                  </el-table-column>
                  <el-table-column align="center"
                                   label="最早时间">
                    <template v-slot="{row}">
                      {{startTimeTrans(row)}}
                    </template>
                  </el-table-column>
                  <el-table-column align="center"
                                   label="最晚时间">
                    <template v-slot="{row}">
                      {{endTimeTrans(row)}}
                    </template>
                  </el-table-column>
                </el-table>

              </el-tab-pane>
              <el-tab-pane label="只能增量删除的集合" name="dataDelByTime">
                <el-table
                  :data="dataDelData"
                  :header-cell-style="{'textAlign':'center'}"
                  style="width: 100%">
                  <el-table-column align="center"
                                   prop="collectionName"
                                   label="集合名称">
                  </el-table-column>
                  <el-table-column align="center"
                                   prop="count"
                                   label="记录数">
                  </el-table-column>
                  <el-table-column align="center"
                                   prop="size"
                                   label="容量大小">
                  </el-table-column>
                  <el-table-column align="center"
                                   label="最早时间">
                    <template v-slot="{row}">
                      {{startTimeTrans(row)}}
                    </template>
                  </el-table-column>
                  <el-table-column align="center"
                                   label="最晚时间">
                    <template v-slot="{row}">
                      {{endTimeTrans(row)}}
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="操作" width="500">
                    <template v-slot="{row}">
                      <el-date-picker v-model="row.delStartTime" type="datetime" placeholder="开始日期" size="small" style="width: 190px;"
                                      value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                      <el-date-picker v-model="row.delEndTime" type="datetime" placeholder="结束日期" size="small" style="width: 190px;margin-left: 10px;"
                                      value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                      <el-button size="mini" type="primary" @click="timeDel(row)" style="margin-left: 10px">增量删除</el-button>

                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane label="可以直接|增量删除的集合" name="dataDelOrByTime">
                <el-button type="primary" size="small" style="float: right;margin-right: 20px;"
                @click="nameDel" v-if="listOperations.some(func => func.name.includes('nameDel'))">开始删除数据</el-button>
                <el-table
                  :data="dataDelData"
                  :header-cell-style="{'textAlign':'center'}"
                  style="width: 100%"
                  @selection-change="handleSelectionChange">
                  <el-table-column align="center"
                                   type="selection"
                                   width="55">
                  </el-table-column>
                  <el-table-column align="center"
                                   prop="collectionName"
                                   label="集合名称">
                  </el-table-column>
                  <el-table-column align="center"
                                   prop="count"
                                   label="记录数">
                  </el-table-column>
                  <el-table-column align="center"
                                   prop="size"
                                   label="容量大小">
                  </el-table-column>
                  <el-table-column align="center"
                                   label="最早时间">
                    <template v-slot="{row}">
                      {{startTimeTrans(row)}}
                    </template>
                  </el-table-column>
                  <el-table-column align="center"
                                   label="最晚时间">
                    <template v-slot="{row}">
                      {{endTimeTrans(row)}}
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="操作" width="500">
                    <template v-slot="{row}">
                      <el-date-picker v-model="row.delStartTime" type="datetime" placeholder="开始日期" size="small" style="width: 190px;"
                                      value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                      <el-date-picker v-model="row.delEndTime" type="datetime" placeholder="结束日期" size="small" style="width: 190px;margin-left: 10px;"
                                      value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                      <el-button size="mini" type="primary" @click="timeDel(row)" style="margin-left: 10px"
                                 v-if="listOperations.some(func => func.name.includes('timeDel'))">增量删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
            </el-tabs>
            <el-pagination
              class="fy"
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10,20,30,40]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalElement"
            ></el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";

  export default {
    name: "DelMongoDB",
    data() {
      return {
        dbHost: "",
        dbUser: "",
        dbPassword: "",
        dbName: "",
        startTime: null,
        endTime: null,
        end: null,
        start: null,
        delStartTime: null,
        delEndTime: null,
        value1:null,
        pageSize: 10,
        currentPage: 1,
        totalElement: 0,
        collectionType: 1,
        connectFlag: "",
        selectDBName: "",
        dataInfo: {},
        activeName: "dataDel",
        dbInfoData: [],
        dbInfoArr: [],
        dataDelData: [],
        dataDelOrByTimeData: [],
        dataDelByTimeData: [],
        collectionList: [],
        newSelect: [],
      }
    },
    created() {
      this.getListOperations('mongoDB')
      if (!this.currentMenu) {
        return
      }
    },
    computed: {
      ...mapState(['currentMenu', 'listOperations', 'currentMenuOperations']),
    },
    methods: {
      ...mapMutations(['getListOperations']),
      handleSelectionChange(val){
        this.collectionList=val;
        this.collectionList.forEach(e=>{
          this.newSelect.push(e.collectionName);
        });
      },
      nameDel(){
        let data = {
          dbHost: this.dbHost,
          dbUser: this.dbUser,
          dbPassword: this.dbPassword,
          auth: this.connectFlag,
          dbName: this.selectDBName,
          collections: this.newSelect
        };
        this.newSelect=[];
        this.$axios.post(this.qoscountServerUrl + 'mongodb/delCollection', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              this.chooseDB();
            } else {
              this.$message({showClose: true, message: msg, type: 'error'});
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      timeDel(item){
        let nameList=[];
        nameList.push(item.collectionName);
        let data = {
          dbHost: this.dbHost,
          dbUser: this.dbUser,
          dbPassword: this.dbPassword,
          auth: this.connectFlag,
          dbName: this.selectDBName,
          collections: nameList ,
          startTime: new Date(item.delStartTime).getTime(),
          endTime: new Date(item.delEndTime).getTime(),
        };
        this.$axios.post(this.qoscountServerUrl + 'mongodb/delCollectionByTime', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              this.chooseDB();
            } else {
              this.$message({showClose: true, message: msg, type: 'error'});
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      startTimeTrans(row){
        if (row.startTime) {
          if(row.startTime.length == 8){
            return row.startTime;
          }else if(row.startTime.length == 10){
            let stime = new Date(row.startTime * 1000).Format('yyyy-MM-dd hh:mm:ss');
            return stime;
          }else if(row.startTime.length == 13){
            let stime = new Date(row.startTime * 1).Format('yyyy-MM-dd hh:mm:ss');
            return stime;
          }
        }else {
          return ""
        }
      },
      endTimeTrans(row) {
        if (row.endTime) {
          if(row.endTime.length == 8){
            return row.endTime;
          }else if(row.endTime.length == 10){
            let etime = new Date(row.endTime * 1000).Format('yyyy-MM-dd hh:mm:ss');
            return etime;
          }else if(row.endTime.length == 13){
            let etime = new Date(row.endTime * 1).Format('yyyy-MM-dd hh:mm:ss');
            return etime;
          }
        }else {
          return ""
        }
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.chooseDB()
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.chooseDB()
      },
      chooseDB(row) {
        if (row) {
          this.selectDBName = row.dbName;
        }
        if (new Date(this.start).getTime() && new Date(this.end).getTime()) {
          if (new Date(this.start).getTime() > new Date(this.end).getTime()) {
            this.$message.error('开始日期不能大于结束日期！');
          } else {
            let data = {
              dbHost: this.dbHost,
              dbUser: this.dbUser,
              dbPassword: this.dbPassword,
              auth: this.connectFlag,
              dbName: this.selectDBName,
              startTime: new Date(this.start).getTime(),
              endTime: new Date(this.end).getTime(),
              pageNo: this.currentPage,
              pageSize: this.pageSize,
              collectionType: this.collectionType,
            };
            this.$axios.post(this.qoscountServerUrl + 'mongodb/listCollection', data)
              .then(({data: {msg, data, code}}) => {
                if (code == 20000) {
                  this.dataDelData = data.dataDel;
                  this.totalElement = data.totalSize;
                } else {
                  this.$message({showClose: true, message: msg, type: 'error'});
                  console.log(msg)
                }
              })
              .catch(err => {
                console.log(err)
              })
          }
        } else {
          this.$message.error('请先选择时间！');
        }
      },
      handleClick(tab) {
        this.currentPage=1;
        if (tab.name == "dataDel") {
          this.collectionType = 1;
          this.chooseDB();
        } else if (tab.name == "dataDelByTime") {
          this.collectionType = 2;
          this.chooseDB();
        } else if (tab.name == "dataDelOrByTime") {
          this.collectionType = 3;
          this.chooseDB();
        }

      },
      isIdentifyConnect(flag) {
        this.start=null;
        this.end=null;
        this.dataDelData=[];
        this.connectFlag = flag;
        this.dbInfoArr = [];
        let data = {
          dbHost: this.dbHost,
          dbUser: this.dbUser,
          dbPassword: this.dbPassword,
          auth: flag,
          dbName: this.dbName
        };
        this.$axios.post(this.qoscountServerUrl + 'mongodb/listDB', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              this.dbInfoData = data;
              if (data) {
                this.dbInfoData.forEach(e => {
                  let obj = {
                    key: "",
                    dbName: ""
                  };
                  obj.key = e.dbName + "【" + e.storageSize + "，集合：" + e.collections + "】"
                  obj.dbName = e.dbName;
                  this.dbInfoArr.push(obj);
                  this.dataInfo = obj;
                });
              }
            } else {
              this.$message({showClose: true, message: msg, type: 'error'});
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    }
  }
</script>

<style scoped>

</style>
